import { Component, DoCheck, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { SalesCategoryService } from '../../../service/sales-category/sales-category.service';
import { SalesGroupService } from '../../../service/sales-group/sales-group.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9165',
  templateUrl: './wa9165.component.html',
  styleUrls: ['./wa9165.component.scss']
})
export class Wa9165Component implements DoCheck, OnChanges {
  public componentTitle = 'WA9165:売上摘要マスタ修正';

  public salescategories: any;
  public salesgroupId: number;
  public salesgroupCd: string;
  public salesgroupTx: FormControl;
  public salescategoryId: number;
  public salesgroupunitTx: FormControl;
  public salescategoryTx: string;

  public validation = validation;

  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  private openwindow: boolean = false;
  @Input() sales: object = [];
  @Output() onSubmitClick = new EventEmitter();

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private isDelayHide = true;
  private isSubmitButtonEnabled = false;

  private salesgroupTxCls = '';
  private salescategoryIdCls = '';
  private salesgroupunitTxCls = '';

  constructor(private salescategoryService: SalesCategoryService, private salesgroupService: SalesGroupService, private commonService: CommonService) {
    this.salescategoryService
      .get()
      .then(outputJson => {
        this.salescategories = outputJson.salescategories;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    sessionStorage.removeItem('wa9165openwindow');
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onSubmit() {
    var salesgroupTx = this.salesgroupTx.value.trim();
    var salesgroupunitTx = this.salesgroupunitTx.value.trim();
    let errors = false;
    if (this.salesgroupTx.errors !== null) {
      this.salesgroupTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.salesgroupunitTx.errors !== null) {
      this.salesgroupunitTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    const updprogramCd: string = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.salesgroupService
      .put(this.salesgroupId, this.salesgroupCd, salesgroupTx, this.salescategoryId, salesgroupunitTx, updprogramCd)
      .then(outputJson => {
        sessionStorage.removeItem('wa9165openwindow');
        this.cancel();
        this.onSubmitClick.emit();
        this.working2 = false;
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working2 = false;
      });
  }

  ngDoCheck() {
    this.openwindow = false;
    if (sessionStorage.getItem('wa9165openwindow') === 'open') {
      this.openwindow = true;
      this.isDelayHide = false;

      this.salesgroupTxCls = this.salesgroupTx.errors != null ? 'error' : this.salesgroupTx.value === this.sales['salesgroupTx'] ? '' : 'active';
      this.salescategoryIdCls = this.salescategoryId + '' === this.sales['salescategoryId'] + '' ? '' : 'active';
      this.salesgroupunitTxCls = this.salesgroupunitTx.errors != null ? 'error' : this.salesgroupunitTx.value === this.sales['salesgroupunitTx'] ? '' : 'active';
    }
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.salesgroupTxCls !== this.STRINGS_ERROR &&
      this.salescategoryIdCls !== this.STRINGS_ERROR &&
      this.salesgroupunitTxCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.salesgroupTxCls === this.STRINGS_ACTIVE ||
        this.salescategoryIdCls === this.STRINGS_ACTIVE ||
        this.salesgroupunitTxCls === this.STRINGS_ACTIVE;
    }
    else {
      this.isSubmitButtonEnabled = false;
    }

  }

  cancel() {
    this.errorInfo = '';

    sessionStorage.removeItem('wa9165openwindow');
    this.openwindow = false;
    setTimeout(() => {
      this.isDelayHide = true;
    }, 300);
    this.working = false;
    this.ngOnChanges();
  }

  ngOnChanges() {
    if (this.sales) {
      const salescategory: object = this.sales;
      this.salescategoryId = salescategory['salescategoryId'];
      this.salescategoryTx = salescategory['salescategoryTx'];
      this.salesgroupId = salescategory['salesgroupId'];
      this.salesgroupCd = salescategory['salesgroupCd'];
      var salesgroupTx = salescategory['salesgroupTx'];
      var salesgroupunitTx = salescategory['salesgroupunitTx'];
      (this.salesgroupTx = new FormControl(salesgroupTx, [
        Validators.required,
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salesgroupTx.maxLength)
      ])),
        (this.salesgroupunitTx = new FormControl(salesgroupunitTx, [
          Validators.required,
          Validators.pattern(validation.emBlankOnly),
          Validators.pattern(validation.halfBlankOnly),
          Validators.maxLength(validation.salesgroupunitTx.maxLength)
        ])),
        (this.containerHeight = window.innerHeight - config.containerheaderMargin);
    }
  }

  changes(event) {
    this.errorInfo = '';

    if (!this.salesgroupunitTx.errors && !this.salesgroupTx.errors && this.salescategoryId !== 0) {
      if (this.sales['salesgroupTx'] === event.target.value || this.sales['salesgroupunitTx'] === event.target.value || this.sales['salescategoryId'] === event.target.value) {
        this.working = false;
      } else {
        this.working = true;
      }
    } else {
      this.working = false;
    }

    if (event.target.value === '') {
      this.working = false;
    }
  }

  clrErr() {
    this.errorInfo = '';
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9165/wa9165.component.ts